import type { InventoryIpgTab } from '../types/inventory';

/** BPO TA (after BPO) at or below this → red replenishment highlight. */
export const LOW_TA_MONTHS = 4.5;

/** BPO TA at or above this → yellow clearance highlight. */
export const CLEARANCE_TA_MONTHS = 6;

/** Obsolete / clearance IPGs — always Clearance, never red replenishment highlight. */
export const CLEARANCE_IPGS = new Set(['FG-OBR', 'FG-OBX']);

export type InventoryAnalysisTabDef = {
  id: InventoryIpgTab;
  label: string;
  ipg: string;
  sheetName: string;
  /** When set, only clearance rows are shown. */
  clearanceOnly?: boolean;
};

export const INVENTORY_ANALYSIS_TABS: InventoryAnalysisTabDef[] = [
  { id: 'FG-FOCUS', label: 'Overview', ipg: 'FG-FOCUS', sheetName: 'Overview' },
  { id: 'FG-XOC', label: 'FG-XOC', ipg: 'FG-XOC', sheetName: 'FG-XOC' },
  { id: 'FG-PD', label: 'FG-PD', ipg: 'FG-PD', sheetName: 'FG-PD' },
  { id: 'FG-R', label: 'FG-R', ipg: 'FG-R', sheetName: 'FG-R' },
  { id: 'FG-OBR', label: 'FG-OBR', ipg: 'FG-OBR', sheetName: 'FG-OBR' },
  { id: 'FG-OBX', label: 'FG-OBX', ipg: 'FG-OBX', sheetName: 'FG-OBX' },
  {
    id: 'CLEARANCE',
    label: 'Clearance',
    ipg: 'FG-FOCUS',
    sheetName: 'Clearance',
    clearanceOnly: true,
  },
];

export function isObrObxIpg(ipg: string | null | undefined): boolean {
  return CLEARANCE_IPGS.has(String(ipg ?? '').trim().toUpperCase());
}

/** Yellow: BPO TA ≥ threshold. */
export function isClearanceTa(ta: number | null | undefined): boolean {
  return ta != null && Number.isFinite(ta) && ta >= CLEARANCE_TA_MONTHS;
}

/** Clearance tab / amber: high BPO TA, or all FG-OBR / FG-OBX. */
export function isClearanceRow(row: {
  ipg?: string | null;
  ta?: number | null;
}): boolean {
  return isObrObxIpg(row.ipg) || isClearanceTa(row.ta);
}

/** Red replenishment — BPO TA ≤ threshold; never for FG-OBR / FG-OBX. */
export function isLowTa(ta: number | null | undefined, ipg?: string | null): boolean {
  if (isObrObxIpg(ipg)) return false;
  return ta != null && Number.isFinite(ta) && ta <= LOW_TA_MONTHS;
}
